import { useEffect, useRef } from 'react';
import { DatePicker, DatePickerInput } from '@carbon/react';
import '@carbon/styles/css/styles.css';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import './datePickerEs.css';
import useScopedTranslation from 'hooks/useScopedTranslation';
import { datePickerEsI18n } from './i18n';

const DatePickerEs = ({
  labelTextLeft,
  labelTextRight,
  initialRange,
  onChange,
}) => {
  const { t } = useScopedTranslation(datePickerEsI18n);
  const pickerRef = useRef(null);
  const pickerInstance = useRef(null);

  useEffect(() => {
    if (!pickerInstance.current) return;

    const picker = pickerInstance.current;

    if (!initialRange?.startDate && !initialRange?.endDate) {
      picker.clear();
      return;
    }

    if (initialRange?.startDate && initialRange?.endDate) {
      picker.setDate([initialRange.startDate, initialRange.endDate], true);
    }
  }, [initialRange]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const input = pickerRef.current?.querySelector('input');

      const picker = input?._flatpickr;
      if (!picker) return;

      picker.set('locale', Spanish);

      pickerInstance.current = picker;

      if (initialRange?.startDate && initialRange?.endDate) {
        picker.setDate([initialRange.startDate, initialRange.endDate], true);
      }

      picker.set('onClose', function (selectedDates) {
        if (selectedDates.length === 2) {
          onChange?.({
            startDate: selectedDates[0],
            endDate: selectedDates[1],
          });
        }
      });
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div ref={pickerRef} style={{ maxWidth: 350 }}>
      <DatePicker datePickerType='range' dateFormat='d/m/Y' light>
        <DatePickerInput
          id='inicio'
          labelText={labelTextLeft}
          placeholder={t('datepicker_placeholder')}
        />
        <DatePickerInput
          id='fin'
          labelText={labelTextRight}
          placeholder={t('datepicker_placeholder')}
        />
      </DatePicker>
    </div>
  );
};

export default DatePickerEs;
